import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import * as moment from "moment";
import { ModalViewBaremeDetailComponent } from "src/app/shared/components/modal-view-bareme-detail/modal-view-bareme-detail.component";


@Component({
  selector: 'app-modal-view-college-detail',
  templateUrl: './modal-view-college-detail.component.html',
  styleUrls: ['./modal-view-college-detail.component.scss']
})
export class ModalViewCollegeDetailComponent implements OnInit {

  busyGet: Subscription;
  filiale_id: any;
  user: any = {};
  currentData: any;
  modalRef: BsModalRef;
  itemCollege: any = {};
  itemsFiliale: any;
  itemsBareme: any;
  itemBareme: any;

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
  ) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id;
    console.log("this.currentData: ", this.currentData);
    setTimeout(() => {
      if (this.currentData) {
        this.getItemCollege(this.currentData.id);
        this.getItemsBareme(this.currentData.bareme_id)
      }
    }, 50);
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {}
      );
  }

  getItemCollege(college_id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        id: college_id,
      },
    };

    this.busyGet = this.restClient
      .post("college/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && res["items"].length) {
            this.itemCollege = res["items"][0];
            this.itemCollege.date_effet = moment(this.itemCollege.date_effet).format('DD/MM/YYYY')
            this.itemCollege.date_echeance = moment(this.itemCollege.date_echeance).format('DD/MM/YYYY')
            this.itemCollege.souscripteur_libelle = this.itemCollege.souscripteur_nom? this.itemCollege.souscripteur_nom+' '+this.itemCollege.souscripteur_prenom : this.itemCollege.souscripteur_libelle
            this.itemCollege.courtier_libelle = this.itemCollege.courtier_nom? this.itemCollege.courtier_nom+' '+this.itemCollege.courtier_prenom : this.itemCollege.courtier_libelle
            this.itemCollege.commerciale = this.itemCollege.commerciale_nom+' '+this.itemCollege.commerciale_prenom

          } else {
            this.itemCollege = {};
          }
        },
        (err) => {
          this.itemCollege = {};
        }
      );
  }

  handleImageError(item) {
    item.image_url = "assets/images/custom/user-ano.jpeg";
  }

  openModalPrestataireReseau() {
    if(!this.itemCollege.reseau_de_soin_id)
      return
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854500,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
 
    let data = {reseau_de_soin_id:this.itemCollege.reseau_de_soin_id,reseau_de_soin_libelle:this.itemCollege.reseau_de_soin_libelle}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
    });
  
  
  }
  openModalDetailBareme() {
    // console.log('itemToSave: ',this.itemToSave)
    if(!this.itemCollege.bareme_id)
      return
    let modal: any;
    modal = ModalViewBaremeDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854512,
      class: "modal-width-90",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let bareme_libelle ='' 
    // if(this.itemsBareme && this.itemsBareme.length)
    bareme_libelle = this.itemBareme.libelle
    let data = {bareme_id:this.itemCollege.bareme_id,bareme_libelle:bareme_libelle}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
    });
  }

  getItemsBareme(id) {
      let request = {
        user_id: this.user.id,
        filiale_id: this.user.filiale_id,
        index: 0,
        size: 1000,
        data: {
          id: id,
        },
      };
  
      this.busyGet = this.restClient
        .post("bareme/getByCriteria", request)
        .subscribe(
          (res) => {
            if (res && res["items"]) {
              // this.itemsBareme = _.orderBy(res["items"], ["libelle"], ["asc"]);
              this.itemBareme = res["items"][0]
            } else {
              this.itemBareme = [];
            }
          },
          (err) => {
            this.itemBareme = {};
          }
        );
    }

  ngOnInit() {
    this.getItemsFiliale();
  }

}
